/**
 * Shown when a page's content could not be loaded for a reason that is not "it does not exist" —
 * a backend restart, a deploy, a dropped connection.
 *
 * Deliberately does NOT set noindex. The 404 view does, and Google crawled a live guide during one
 * of these windows and excluded it by meta tag. A temporary failure must leave the page's own
 * directives alone so a retry can be indexed normally.
 */
export const LoadFailed = ({ what = "this page" }) => (
  <div
    data-testid="load-failed"
    className="max-w-[760px] mx-auto px-5 md:px-8 py-24 md:py-32 text-center"
  >
    <h1 className="display text-[32px] md:text-[42px] leading-[1.1] text-charcoal">
      We couldn't load {what} just now
    </h1>
    <p className="text-[17px] font-light leading-[1.55] text-[#4F4F4F] mt-5">
      This is temporary — the content is still here. Refreshing usually fixes it.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      data-testid="load-failed-retry"
      className="mt-9 px-8 py-4 bg-charcoal text-white text-[12.5px] tracking-[0.16em] uppercase hover:bg-sage transition-colors duration-300"
    >
      Try again
    </button>
  </div>
);
